import {useTranslation} from 'react-i18next'

const EmptyNotification = () => {
 const {t} = useTranslation()
 return (
  <div className='w-full py-20 flex items-center justify-center'>
   <div className='text-[#7E8299] mt-2'>
    {t('notification.notificationText')}
   </div>
  </div>
 )
}

export default EmptyNotification
